const ANCHOR_LEN = 40

function exactMatch(chunkText, parentText) {
  const i = parentText.indexOf(chunkText)
  return i === -1 ? null : { start: i, end: i + chunkText.length }
}

function normalisedMatch(chunkText, parentText) {
  let normParent = ''
  const map = []
  let prevWasSpace = false
  for (let j = 0; j < parentText.length; j++) {
    const c = parentText[j]
    if (/\s/.test(c)) {
      if (!prevWasSpace && normParent.length > 0) {
        normParent += ' '
        map.push(j)
      }
      prevWasSpace = true
    } else {
      normParent += c.toLowerCase()
      map.push(j)
      prevWasSpace = false
    }
  }
  while (normParent.endsWith(' ')) {
    normParent = normParent.slice(0, -1)
    map.pop()
  }
  const normChunk = chunkText.replace(/\s+/g, ' ').trim().toLowerCase()
  if (!normChunk) return null
  const i = normParent.indexOf(normChunk)
  if (i === -1) return null
  const start = map[i]
  const lastIdx = i + normChunk.length - 1
  const end = lastIdx < map.length ? map[lastIdx] + 1 : parentText.length
  return { start, end }
}

function anchorMatch(chunkText, parentText) {
  const stripped = chunkText.trim()
  if (stripped.length < ANCHOR_LEN * 2) return null
  const anchorStart = stripped.slice(0, ANCHOR_LEN)
  const anchorEnd = stripped.slice(-ANCHOR_LEN)
  const startIdx = parentText.indexOf(anchorStart)
  if (startIdx === -1) return null
  const endSearchFrom = startIdx + anchorStart.length
  const endIdx = parentText.indexOf(anchorEnd, endSearchFrom)
  if (endIdx === -1) return null
  const span = endIdx + anchorEnd.length - startIdx
  const expected = chunkText.length
  if (Math.abs(span - expected) / expected > 0.25) return null
  return { start: startIdx, end: endIdx + anchorEnd.length }
}

export function locateChunk(chunkText, parentText) {
  if (!chunkText || !parentText) return null
  return (
    exactMatch(chunkText, parentText) ||
    normalisedMatch(chunkText, parentText) ||
    anchorMatch(chunkText, parentText)
  )
}
